import type { Language } from '@kk/domain';

/**
 * **THE CLUBS PORTAL'S LANGUAGE, RIGHT NOW** (Spanish for 3.0.11; Evan, 28 Sep). Kept here with nothing else so that
 * anything that words a line — the deck, `lib/time.ts` — can read it without importing the deck. Only
 * `setPortalLanguage` (copy/applyLanguage.ts) changes it; the admin host never does, so it stays English there.
 */
let active: Language = 'en';

export function portalLanguage(): Language {
  return active;
}

/** For copy/applyLanguage.ts only: it rewrites the deck first, then records the language. */
export function recordPortalLanguage(language: Language): void {
  active = language;
}
